{
  "dependencies": {
    "@auth0/angular-jwt": "^5.2.0",
    "@aws-sdk/client-lambda": "^3.812.0",
    "@ctrl/ngx-emoji-mart": "^7.1.0",
    "@dhutaryan/ngx-mat-timepicker": "^19.0.0",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/operators": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@stomp/rx-stomp": "^1.1.4",
    "agora-extension-ai-denoiser": "^1.0.0",
    "agora-rtc-sdk-ng": "^4.14.0",
    "date-fns": "^3.6.0",
    "date-fns-tz": "^3.1.3",
    "emoji-regex": "^10.4.0",
    "file-saver": "^2.0.5",
    "handlebars": "^4.7.8",
    "jwt-decode": "^3.1.2",
    "libphonenumber-js": "^1.10.14",
    "lodash": "^4.17.21",
    "ngx-avatars": "^1.9.3",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-mat-intl-tel-input": "^5.0.0",
    "ngx-material-intl-tel-input": "^21.1.0",
    "ngx-skeleton-loader": "^7.0.0",
    "normalize.css": "^8.0.1",
    "sockjs-client": "^1.6.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.0.1",
    "@angular-eslint/builder": "^22.0.0",
    "@angular/cli": "^22.0.1",
    "@angular/compiler-cli": "^22.0.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@sentry/webpack-plugin": "^1.20.0",
    "@types/crypto-js": "^4.1.1",
    "@types/file-saver": "^2.0.7",
    "@types/lodash": "^4.14.178",
    "@types/node": "^20.12.7",
    "@types/sockjs-client": "^1.5.1",
    "@typescript-eslint/eslint-plugin": "^5.43.0",
    "@typescript-eslint/parser": "^5.43.0",
    "copy-webpack-plugin": "^11.0.0",
    "eslint": "^8.28.0",
    "eslint-config-prettier": "^8.5.0",
    "eslint-plugin-import": "^2.26.0",
    "eslint-plugin-jsdoc": "^39.1.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^4.2.1",
    "husky": "^9.0.10",
    "ng-packagr": "^22.0.0",
    "prettier": "^2.5.1",
    "pretty-quick": "^3.1.3",
    "standard-version": "^9.5.0",
    "typescript": "^6.0.3"
  },
  "name": "@truvideo/ngx-messaging",
  "peerDependencies": {
    "rxjs": "^7.8.1",
    "util": "^0.12.4",
    "zone.js": "^0.16.2"
  },
  "publishConfig": {
    "registry": "https://npm.pkg.github.com/@truvideo"
  },
  "scripts": {
    "patch": "version patch"
  },
  "sideEffects": false,
  "version": "8.0.1-rc.11"
}
